import React from 'react'

const CustomLoader = () => {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-60 flex items-center justify-center z-50 ">
      <div className="text-center mt-5">
        <img
          src="https://www.finedge.in/assets/images/download.gif"
          alt="Loading..."
          className="w-24 h-24 mx-auto"
        />
        <p className="text-white text-lg mt-4">Please wait...</p>
      </div>
    </div>
  )
}

export default CustomLoader
